import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useGoober } from "../../../Design/GooberContext";
import { mobileMediaQuery } from "../../../Design/mediaQuery";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { SectionContainer } from "../../../Utils/SectionContainer";
import { defaultStyles } from "./defaultStyles";

const columnMediaQuery = `
  display: block;
  width: 100% !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
`;

interface ImageGalleryBlock3Props extends ComponentPropsWithRef<"table"> {
  headerContent: ReactNode;
  imageNode1?: ReactNode;
  imageNode2?: ReactNode;
  imageNode3?: ReactNode;
  imageNode4?: ReactNode;
  imageNode5?: ReactNode;
  imageNode6?: ReactNode;
  imageNode7?: ReactNode;
  imageNode8?: ReactNode;
  imageNode9?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const ImageGalleryBlock3 = forwardRef<
  HTMLTableElement,
  ImageGalleryBlock3Props
>(
  (
    {
      headerContent,
      imageNode1,
      imageNode2,
      imageNode3,
      imageNode4,
      imageNode5,
      imageNode6,
      imageNode7,
      imageNode8,
      imageNode9,
      styles = {},
      ...rest
    },
    ref,
  ) => {
    const { css } = useGoober();

    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
      },
    );

    return (
      <SectionContainer cssProperties={marginStyles}>
        <Section
          ref={ref}
          style={{
            ...paddingStyles,
            ...backgroundStyles,
          }}
          {...rest}
        >
          <Row>
            <Column>{headerContent}</Column>
          </Row>
          <Row cellPadding={0}>
            {/* Column 1 */}
            <Column
              style={{ width: "33.33%" }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery} margin-bottom: 16px;
                }
              `}
            >
              <div>{imageNode1}</div>
              <div>{imageNode2}</div>
              <div>{imageNode3}</div>
            </Column>

            {/* Column 2 */}
            <Column
              style={{ width: "33.33%" }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery} margin-bottom: 16px;
                }
              `}
            >
              <div>{imageNode4}</div>
              <div>{imageNode5}</div>
              <div>{imageNode6}</div>
            </Column>

            {/* Column 3 */}
            <Column
              style={{ width: "33.33%" }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery}
                }
              `}
            >
              <div>{imageNode7}</div>
              <div>{imageNode8}</div>
              <div>{imageNode9}</div>
            </Column>
          </Row>
        </Section>
      </SectionContainer>
    );
  },
);

ImageGalleryBlock3.displayName = "ImageGalleryBlock3";
